export const selectAllIssues = (state) => state.issues.allIssues;
export const selectIsFormOpened = (state) => state.issues.isFormOpened;
export const selectContentForIssue = (state) =>
  state.issues.selectedIssue.content;
export const selectIssueId = (state) => state.issues.selectedIssue.issueId;
export const selectIssueLoading = (state) => state.issues.loading;
